import { useQuery } from "@tanstack/react-query";
import { AxiosError } from "axios";

import { campaignJobBoardQueryKeys } from "./queryKeys";

import { instance } from "@/lib/axios/instance";
import { CampaignJobBoardType } from "@/types/response/CampaignJobBoardType";
import { PagedResponse } from "@/types/response/PagedResponse";

interface UseCampaignJobBoardsParams {
  campaignId: string;
  clientId?: string;
}

export function useCampaignJobBoards({
  campaignId,
  clientId,
}: UseCampaignJobBoardsParams) {
  return useQuery<PagedResponse<CampaignJobBoardType>, AxiosError>({
    queryKey: campaignJobBoardQueryKeys.list(campaignId, clientId),
    queryFn: () =>
      instance
        .get<PagedResponse<CampaignJobBoardType>>(
          `/api/v2/Campaigns/${campaignId}/Integrations`,
          {
            params: {
              clientId,
            },
          },
        )
        .then((res) => res.data),
    enabled: !!campaignId,
    refetchOnReconnect: false,
    staleTime: 20 * 60 * 1000,
  });
}
